import { render, staticRenderFns } from "./ClubRepository.vue?vue&type=template&id=09a0065a"
import script from "./ClubRepository.vue?vue&type=script&lang=js"
export * from "./ClubRepository.vue?vue&type=script&lang=js"
import style0 from "./ClubRepository.vue?vue&type=style&index=0&id=09a0065a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports